import * as React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import { IonButton, IonCard, IonItem, IonList, IonRow, IonSelect, IonSelectOption } from "@ionic/react";
import { useTranslations } from "../../hooks/useTranslations";

export default function SurveyFields({ handleAddGroups, providers, onProviderSelect, selectedProviders }) {
    const [surveyName, setSurveyName] = React.useState('')
    const [surveyDesc, setSurveydesc] = React.useState('')
    const labels = useTranslations()

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 400,
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4
    };

    return (
        <IonRow>
            <TextField
                style={{ width: 300, marginRight: 20, marginLeft: 20 }}
                id="outlined-basic"
                label={labels.SurveyName}
                variant="outlined"
                value={surveyName}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setSurveyName(event.target.value)
                }}
            />

            <TextField
                style={{ width: 300, marginRight: 20 }}
                id="outlined-basic-desc"
                label={labels.SurveyDescription}
                variant="outlined"
                // disabled={_.isEmpty(groupArray)}
                value={surveyDesc}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    setSurveydesc(event.target.value)
                }}
            />
            {/* <IonList > */}
            {/* <IonItem> */}
            <IonSelect
                style={{ height: 30, borderRadius: 5, width: 300, borderColor: 'lightgrey', borderWidth: 1, color: 'black' }}
                aria-label="Providers"
                placeholder={labels.Selectallprovidersthatapply}
                onIonChange={(e) => {
                    onProviderSelect(e)
                }}
                value={selectedProviders}
                multiple={true}>
                {providers?.map((pr, i) => {
                    return (
                        <IonSelectOption key={pr.providerCode}>{pr.providerName}({pr.providerCode})</IonSelectOption>
                    )
                })}

            </IonSelect>
            {/* </IonItem> */}
            {/* </IonList> */}
            <IonButton
                size="default"
                color="primary"
                style={{ marginLeft: 30, height: 50, marginBottom: 10 }
                }
                onClick={() => {
                    handleAddGroups(surveyName, surveyDesc, false, '{}')
                    setSurveyName('')
                    setSurveydesc('')
                }
                }> + {labels.AddSurvey} </IonButton >

        </IonRow>

    )
}
